import {
  clearAllDropdownCache,
  getMetadata,
  saveMetadata,
} from "../db/indexedDB";
import { getCodesWithCache } from "../hooks/getCodesWithCache";
import apiClient from "./ApiClient/apiClientAxios";

const VERSION_KEY = "cache_version";

export const checkAndUpdateCache = async () => {
  try {
    const { data } = await apiClient.get("/version");
    const { timestamp, configs } = data;
    const localTimestamp = await getMetadata(VERSION_KEY, null);
    console.log("Server timestamp:", timestamp);
    console.log("Local timestamp:", localTimestamp);

    if (!localTimestamp || timestamp > localTimestamp) {
      console.log("Cache is stale — refreshing configs:", configs);
      await clearAllDropdownCache();

      for (const code of configs) {
        await getCodesWithCache(code, null);
      }
      await saveMetadata(VERSION_KEY, null, timestamp);
      console.log("Cache updated successfully ✅");
    } else {
      console.log("Cache is fresh ✅");
    }
  } catch (err) {
    console.error("Cache version check failed:", err);
  }
};
